import React, { useEffect, useState, useMemo } from 'react'
import { useNavigate } from 'react-router-dom'
import { listEvents } from '../../services/events'
import EventCard from '../../components/EventCard'
import MobileBottomNav from '../../components/MobileBottomNav'

const EventsPage = () => {
  const navigate = useNavigate()
  const [events, setEvents] = useState([])
  const [loading, setLoading] = useState(true)
  const [search, setSearch] = useState('')

  useEffect(() => {
    const load = async () => {
      setLoading(true)
      const res = await listEvents()
      if (res.status === 200) {
        setEvents(Array.isArray(res.data) ? res.data : [])
      }
      setLoading(false)
    }
    load()
  }, [])

  const filtered = useMemo(() => {
    if (!search) return events
    const term = search.toLowerCase()
    return events.filter(e =>
      (e.title || '').toLowerCase().includes(term) ||
      (e.venue || '').toLowerCase().includes(term) ||
      (e.description || '').toLowerCase().includes(term)
    )
  }, [events, search])

  return (
    <div className="min-h-screen bg-gradient-to-b from-white via-slate-50 to-white pb-20 lg:pb-0">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <header className="mb-10">
          <div className="flex items-center justify-between gap-4 flex-wrap">
            <div>
              <p className="text-sm font-semibold text-emerald-700">Discover Events</p>
              <h1 className="text-3xl sm:text-4xl font-extrabold text-slate-900 mt-2">Find your next experience</h1>
              <p className="text-slate-600 mt-2">Browse curated events and grab tickets in seconds.</p>
            </div>
            <div className="w-full sm:w-64">
              <input
                type="search"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                placeholder="Search events"
                className="w-full rounded-lg border border-slate-200 bg-white px-4 py-2.5 text-sm text-slate-900 shadow-sm focus:outline-none focus:ring-2 focus:ring-emerald-500"
              />
            </div>
          </div>
        </header>

        {loading ? (
          <div className="py-20 text-center text-slate-500 text-sm">Loading events...</div>
        ) : filtered.length === 0 ? (
          <div className="py-16 text-center bg-white border border-dashed border-slate-200 rounded-2xl">
            <p className="text-lg font-semibold text-slate-900 mb-2">No events found</p>
            <p className="text-slate-600">Try another search or check back later.</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {filtered.map(evt => (
              <EventCard key={evt._id || evt.id} event={evt} />
            ))}
          </div>
        )}
      </div>
      <MobileBottomNav />
    </div>
  )
}

export default EventsPage



